module.exports = __webpack_public_path__ + "static/img/no-help.1e9b8ee3.png";